import { Directive } from '@angular/core';

@Directive({
  selector: '[companyMarker]',
})
export class CompanyMarker {}
